module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3OnfJ"))).then(() => parcelRequire('fThBo'));